export const HomeBgImage =
  "https://d1csarkz8obe9u.cloudfront.net/posterpreviews/iphone-17-design-template-757676616525c4e98dc908fb57436bcb_screen.jpg?ts=1758206817";
export const logo = "/assets/images/logo.png";
export const Avatar = "/assets/images/Avatar 4.png";
export const MainCardImage = "/assets/images/MainCardImage.png";
export const LoginContainer = "/assets/images/Product container.png";
export const ProductImage1 =
  "/assets/images/19ca03173e58c954dc14e09cce8c8759a43a7103.jpg";
export const ProductImage2 =
  "/assets/images/a0884c5b24631cab11f6f2dd27b227f06320cad7.jpg";
export const ProductImage3 =
  "/assets/images/e603fa1810fafa996ff0a840c8f5ed100dd013de.jpg";
export const ProductImage4 =
  "/assets/images/ef343264246d73aa7da2c853e7d4c8b71223733b.png";
export const ProductImage5 =
  "/assets/images/38ad9dc08a6b46a25ea2a8f58e556da6506d147f.jpg";
export const ProductImage6 =
  "/assets/images/1a1c468a229dbf881b4fa585c2ebbf483357a7d6.jpg";
export const logo_w = "/assets/images/logo_white.png";
export const Footer_img = "/assets/images/Footer Section.png";
export const SiguUpOne = "/assets/images/Customer icon.svg";
export const SiguUpTwo = "/assets/images/Seller icon.svg";
export const Success = "/assets/images/Success icon.png";
export const Illustration = "/assets/images/Illustration Container.png";
export const HomeImage2 = "/assets/images/Featured Product Section.png";
export const Frame_5 = "/assets/images/Frame 5.png";
export const Frame_6 = "/assets/images/Shopping and Retail _ shop, store, cart, basket, purchase, woman.png";
export const Frame_7 = "/assets/images/Transportation and Logistics _ car, vehicle, transport, explosion, explosive.png";
export const Frame_8 = "/assets/images/Social media and communication _ phone, device, screen, call, phone, talk.png";
export const Frame_9 = "/assets/images/Frame 2147235947.png";
export const Frame_10 = "/assets/images/Social media and communication _ call, talk, conversation, video, window, browser.png";
export const Frame_11 = "/assets/images/Utilities and tools _ website, browser, window, web, development, image, photo, picture.png";
export const Frame_12 = "/assets/images/Marketing and advertising _ website, browser, discount, sale, percent, percentage, checkmark.png";
export const Frame_13 = "/assets/images/Tech and innovation _ website, window, browser, web, development, man, presentation.png";
